import {API_VERSION} from '@/utils/constants/commonConstants';
import {HTTP_METHODS} from '@/utils/constants/httpMethods';

export const RACK_CATALOG_CONFIG = {
  RACK_CATALOG_LIST: () => ({
    endPoint: 'rack-catalog',
    method: HTTP_METHODS.GET
  }),
  CREATE_RACK: {
    endPoint: 'rack-catalog',
    version: API_VERSION.V1,
    method: HTTP_METHODS.POST
  },
  UPDATE_RACK: (id) => ({
    endPoint: `rack-catalog/${id}`,
    method: HTTP_METHODS.PUT
  }),
  DELETE_RACK: (id) => ({
    endPoint: `rack-catalog/${id}`,
    method: HTTP_METHODS.DELETE
  })
};
